export type CastScale = '2_step' | '3_step' | '5_step';
export type SurveyQuestionVariant =
  | 'need_more_help'
  | 'anything_else_help'
  | 'anything_else_do'
  | 'need_human_assistance';

export type SurveySettingsDto = {
  popup_after_messages: number | null;
  popup_after_minutes: number | null;
  cast_scale: CastScale;
  question_variant: SurveyQuestionVariant;
};

export type UpdateSurveySettingsDto = Partial<SurveySettingsDto>;

export const POPUP_AFTER_MESSAGES_OPTIONS = [2, 4, 6] as const;
export const POPUP_AFTER_MINUTES_OPTIONS = [5, 10, 20] as const;
export const CAST_SCALE_OPTIONS: CastScale[] = ['2_step', '3_step', '5_step'];
// 'need_human_assistance' is deliberately absent: the backend understands it, but a
// revision older than the one that added it cannot parse the stored value, so the option
// is withheld from the sheet until that revision is out of rotation.
export const QUESTION_VARIANT_OPTIONS: SurveyQuestionVariant[] = [
  'need_more_help',
  'anything_else_help',
  'anything_else_do',
];
